import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'  // 注册为全局单例服务
})
export class ExecutionTrackerService {
    // 使用Map存储执行状态，key为方法标识，value为是否已执行
    private executedMap = new Map<string, boolean>();

    /**
     * 检查指定方法是否已执行
     * @param methodKey 方法的唯一标识
     * @returns 是否已执行
     */
    isExecuted(methodKey: string): boolean {
        return this.executedMap.get(methodKey) || false;
    }

    /**
     * 标记方法为已执行
     * @param methodKey 方法的唯一标识
     */
    markAsExecuted(methodKey: string): void {
        this.executedMap.set(methodKey, true);
    }

    /**
     * 如果方法未执行过，则执行它
     * @param methodKey 方法的唯一标识
     * @param method 要执行的方法
     */
    executeOnce(methodKey: string, method: () => void): void {
        if (!this.isExecuted(methodKey)) {
            method();
            this.markAsExecuted(methodKey);
        }
    }

    /**
     * 重置某个方法的执行状态（可选）
     * @param methodKey 方法的唯一标识
     */
    resetExecution(methodKey: string): void {
        this.executedMap.delete(methodKey);
    }
}